import React from 'react';
export function FearNarrative() {
  return <section className="bg-white py-20 px-4" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <div className="prose prose-lg md:prose-xl text-zinc-800" data-id="element-23">
          <p className="font-montserrat font-bold text-2xl md:text-3xl text-black mb-6 leading-snug" data-id="element-24">
            It's 2:14 AM. The lights flicker and go dark.
          </p>

          <p className="mb-6" data-id="element-25">
            You reach for your phone—<strong data-id="element-26">No Signal</strong>. You try the
            faucet—<strong data-id="element-27">Nothing but a dry hiss</strong>. You look out the
            window and see your entire city in total, heavy silence.
          </p>

          <p className="font-montserrat font-bold text-xl md:text-2xl text-brand-red mb-8" data-id="element-28">
            What is your very next move?
          </p>

          <p className="mb-6" data-id="element-29">
            If your answer is "wait for the government," you are gambling with
            your family's life. In 2026, the U.S. power grid, supply chains, and
            urban stability are thinner than they've ever been.
          </p>

          <p className="mb-8" data-id="element-30">
            Most "survival" advice is for people with mountain cabins and
            $50,000 in gold. But what about the 99% of us? Normal families in
            suburbs or apartments who just want to keep their kids safe, fed,
            and warm when the world stops?
          </p>

          <div className="border-l-4 border-brand-orange pl-6 py-2 italic text-zinc-600" data-id="element-31">
            Most survival systems were built for mountain men with bunkers. We
            built this for the father in Austin who works 9-to-5 and needs his
            family safe by Sunday.
          </div>
        </div>
      </div>
    </section>;
}